import { DealWithFarthestState } from '../pages/dashboard/utils';
import { sameEmail } from '../utils/customer';

const useHideCobuyer = (deal?: DealWithFarthestState) => {
  return deal?.isCobuyer && sameEmail(deal?.customer, deal?.cobuyer);
};

export default useHideCobuyer;
